
export default {
  SET_CREW_TASKS(state, data) {
    state.crewTasks = data;
  },
}
